import React,{Component} from 'react';
import {PostData} from '../service/postData';
import {sendNotification} from '../_notificationSettings/notificationPanel';
import { Helmet } from 'react-helmet';
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import HeaderSection from '../websiteFolder/web_fragment/header';
import FooterPage from '../websiteFolder/web_fragment/footer';
import { Loader } from '@progress/kendo-react-indicators';

export default class homePagePanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoaded : false,
            isLoggedin : false,
            visibleStartBtn : false,
            isLoading: false,
            blogArray: [],
            visibleMailsendDialog: false,
            mailsendTitle: '',
            mailsendMessage: 'Thank You For Submitting Your Mobile No. With Vyavsay. You can download the app from the link given below <br></br>{" "}`<a href="https://www.vyavsay.in/apk/vyavsay.apk"> https://www.vyavsay.in/apk/vyavsay.apk </a>',
            mobileNumber: '',
            mobileErrorMessage: '',
            name:'',
            email:'',
            contact:'',
            message:'',
            errors:{
                name:'',
                email:'',
                contact:'',
                message:'',
            },
            expanded1: false,
            expanded2: false,
            expanded3: false,
            expanded4: false,

        }
    }

    async componentDidMount(){
        this.renderBlogView(0,'N');
    }


    renderBlogView(categoryId,know)
    {
        let _blogArray = [];
        
        let _url_GetData = global.webistePageBlogList+'?categoryId='+categoryId+'&limit=0,3';
        PostData(_url_GetData,'','GET').then(result => {
            let responseJson = result;
            if(responseJson.success == false)
            {  
                this.setState({isLoaded:true});                
            }
            else
            {
                let onRemainCount = 0;
                if (responseJson.response) {
                    _blogArray = responseJson.response;
                }
                this.setState({blogArray:_blogArray,isLoaded:true});               
            }             
        })
        .catch(error => this.setState({ error, isLoaded: false }));
    }

    viewWebsiteBlogListing()
    {   
        if(this.state.isLoaded == true)
        {
            let _blogDetails = this.state.blogArray;
            let dataList = [];

            if(_blogDetails.length > 0)
            {                          
                _blogDetails.map((compDatas, i) =>
                {
                    const row = compDatas;

                    let _imageUrl = global.webUrl+'img/blog_1.png';
                    if(row.image!=""){
                        _imageUrl = row.image;
                    }
                    
                    let _bTitle = atob(row.title);
                    let url_titles = _bTitle.replace(/ /gi,'-');
                    let url_title = url_titles.replace("?", "_");
                    let blog_id = row.blog_id;
                    let _finalUrl = global.webUrl+'blog/'+blog_id+'/'+url_title+'/';
                    let _shortDesc = atob(row.short_description);

                    dataList.push(
                        <div className="col-lg-4">
                            <div className=" card">
                                <a href={_finalUrl} className="link_poet">
                                    <div className="cover_link">
                                        <img className="card-img_top main_img" src={_imageUrl} alt="..." />
                                    </div>
                                </a>
                                <div className="card-body">
                                    <a href={_finalUrl} className="d-block">
                                        <h5 className="card-title">{_bTitle}</h5>
                                    </a>
                                    <p className="card-text">{_shortDesc}</p>
                                    <br/>
                                    <a href={_finalUrl} className="btn3">Read Full Blog</a>                                    
                                </div>
                            </div>
                        </div>
                    );
                })
            }
            return dataList;
        }
    }

    handleChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        let errors = this.state.errors;
        this.setState({isDisabled:false});
        switch (name) {
            case 'name': 
            errors.name = 
                value.length < 3 ? '*Name must be 3 characters long!' : '';
                this.setState({name:value}); 
            break;
            case 'email': 
                errors.email = value.length < 5 ? '*Please enter valid email id!' : '';
                this.setState({email:value}); 
            break;
            case 'contact': 
                errors.contact = value.length < 5 ? '*Please enter valid mobile no.!' : '';
                if (/^\d*$/.test(value)) {
                    if (value.length >= 0 && value.length <= 10) {
                        this.setState({contact:value}); 
                    }
                  }else{
                    errors.contact = "*Please enter valid mobile no.!";
                  }
                  
                
            break;
            case 'message': 
                errors.message =  value.length < 0 ? '*Please enter some message!' : '';
                this.setState({message:value}); 
            break;
            default:
            break;
        }
    }

    clickToSubmitEnqury = (event) => {
        event.preventDefault();
        let errors = this.state.errors;
        let _isError = false;
        if(this.state.name == '')
        {
            _isError = true;
            errors['name'] = "*Name must be 3 characters long!";
            this.setState({errors: errors});
        }
        const regex = /^\d{10}$/;
        if(regex.test(this.state.contact)){
            
        }else{
            _isError = true;
            errors['contact'] = "*Please Enter Contact No.";
            this.setState({errors: errors});
            alert('Mobile number is invalid.')
        }
        
        const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
        
        if(this.state.email && isValidEmail.test(this.state.email)){
            
        }else{
            _isError = true;
            errors['email'] = "*Please Enter Email-Id.";
            this.setState({errors: errors});
        }
        
        if(this.state.message == "")
        {
            _isError = true;
            errors['message'] = "*Please Enter Some Message.";
            this.setState({errors: errors});
        }

        if(_isError == false){
            this.getTouchFormSubmit();
        }
    }

    getTouchFormSubmit()
    {
        this.setState({isLoading: true});
        const requestData = JSON.stringify({
            name: this.state.name,
            contact: this.state.contact,
            email: this.state.email,
            message: this.state.message,
        });
        
        PostData(global.sendGetInTouchMail, requestData,'POST').then((result) => {
            if(result.success == true)
            {
                this.setState({name: '',contact: '',email: '',message: ''});
                this.setState({
                  visibleMailsendDialog: true,
                  mailsendTitle: result.title,
                  mailsendMessage: result.message,
                });
            }
            else
            {
                sendNotification("Error Message 😓","Some error occured. Please try again.","danger");
            }
        }).finally(() => {
            this.setState({isLoading: false});
        });
    }

    getStartBtn = (event) => {
        event.preventDefault();
        const regex = /^\d{10}$/;
        if(regex.test(this.state.mobileNumber)){
            this.setState({isLoading: true});
            const requestData = JSON.stringify({
                contact: this.state.mobileNumber,
            });
            
            PostData(global.sendAppDownloadMail, requestData,'POST').then((result) => {
                if(result.success == true)
                {    console.log('result', JSON.stringify(result))
                    this.setState({mobileNumber: ''});
                    this.setState({
                      visibleStartBtn: true,
                      mailsendTitle: result.title,
                      mailsendMessage: result.message,
                    });
                }
                else
                {
                    sendNotification("Error Message 😓","Some error occured. Please try again.","danger");
                }
            }).finally(() => {
                this.setState({isLoading: false});
            });
        }else{
            alert('Mobile number is invalid.')
        }
    }


    handleInputChange = (event) => {
        const value = event.target.value;
    
        if (/^\d*$/.test(value)) {
          if (value.length >= 0 && value.length <= 10) {
            this.setState({mobileNumber: value})
          }
        }
      };

    render(){
        const {errors} = this.state;
        const isDisabled = Object.keys(errors).some(x => errors[x]);
        return (
          <React.Fragment>
            <Helmet>
              <title>Vyavsay App</title>
              <meta name="description" content="Vyavsay App" />
              <meta name="keywords" content="Vyavsay App" />
            </Helmet>
            <div id="page-wrapper">
              <div id="main" className="mainSectionWebsite">
                <section className="header" id="headerSectionLogo">
                  <div className="container" id="menuSection">
                    <HeaderSection />
                    {/* <!-- Banner --> */}
                    <div className="row hero has_style1">
                      <div className="col-lg-8">
                        <h1 className="txt-title-1">
                          A Comprehensive Tax{" "}
                          <b>Billing & Stock Inventory Software</b> Designed for
                          Global Small Businesses
                        </h1>
                        <br />
                        <form className="banner_form">
                          <input
                            type="text"
                            value={this.state.mobileNumber}
                            onChange={this.handleInputChange}
                            placeholder="Enter your mobile number"
                          />
                          <button type="submit" onClick={this.getStartBtn}>
                            Get Started
                          </button>
                          <div className="clearfix"></div>
                        </form>
                      </div>
                      <div className="col-lg-4">
                        <img
                          src={
                            global.webUrl +
                            "websiteFilesFolder/img/banner-img.png"
                          }
                          alt=""
                          title=""
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="after_header">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="block1">
                          <span>
                            <i className="fas fa-star"></i>
                          </span>
                          <h3>Highly Rated</h3>
                          <p>Above 60,658 ratings on Google Play Store</p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="block1 block2">
                          <span>
                            <i className="fas fa-download"></i>
                          </span>
                          <h3>5 Million+ Downloads</h3>
                          <p>More than 30,00,000 satisfied users</p>
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="block1">
                          <span>
                            <i className="fas fa-check-double"></i>
                          </span>
                          <h3>Completely Free</h3>
                          <p>Our mobile app (Android) is Free for Lifetime</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <h2 className="txt-title-3">
                          Create Professional Tax Bills & Instantly Share Them
                          with Your Customers
                        </h2>
                        <span className="line"></span>
                        <p className="txt-style1">
                          <strong>Say goodbye to manual invoicing!</strong>{" "}
                          <strong>
                            With Vyavsay’s advanced billing software,
                          </strong>{" "}
                          you can effortlessly generate accurate, tax-compliant
                          invoices in just a few clicks. Whether you're billing{" "}
                          {this.state.expanded1 ? "" : "..."}
                        </p>
                        {this.state.expanded1 && (
                          <div>
                            <p className="txt-style1">
                              local clients or international customers, Vyavsay
                              ensures that every invoice aligns with the
                              required tax standards and formats—saving you time
                              and reducing errors.
                              <br />
                              <br />
                              Stay ahead with <strong>real-time invoice sharing</strong> through
                              Vyavsay—email or download professional tax bills
                              instantly and deliver them directly to your
                              customers. It not only builds trust but also
                              accelerates payments and keeps your financial
                              records well-organized. <strong>Simple, fast, and fully
                              compliant</strong>—Vyavsay is built for the needs of
                              today’s growing businesses.
                              <br />
                            </p>
                          </div>
                        )}

                        <div className="btn-container" align="center">
                          <button
                            id='toggle'
                            onClick={() =>
                              this.setState({
                                expanded1: !this.state.expanded1,
                              })
                            }
                          >
                            {this.state.expanded1 ? "Read Less" : "Read More"}
                          </button>
                        </div>
                        <br />
                        <br />
                        <div align="center">
                          <img
                            src={
                              global.webUrl + "websiteFilesFolder/img/sec1.png"
                            }
                            alt=""
                            title=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sec2">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <img
                          src={
                            global.webUrl + "websiteFilesFolder/img/sec2.png"
                          }
                          alt=""
                          title=""
                        />
                      </div>
                      <div className="col-lg-6 space1">
                        <h2 className="txt-title-3">
                          Never Miss a Product with Live Inventory Monitoring
                        </h2>
                        <span className="line"></span>
                        <p className="txt-style1">
                          <b>Smart Inventory, Smarter Business</b>
                        </p>
                        <p className="txt-style1">
                          Vyavsay keeps you in complete control of your
                          inventory. From new stock entries to 
                          {this.state.expanded2 ? " instant low-stock alerts, you’ll get real-time updates that help you make smarter business decisions—on the go." : "..."}
                        </p>

                        {this.state.expanded2 && (
                          <div>
                            <br />
                            <p className="txt-style1">
                              <b>Real-Time Tracking You Can Trust</b>
                            </p>
                            <p className="txt-style1">
                              With Vyavsay, every bill or sale auto-updates your
                              inventory in real time. No manual work, no
                              errors—just smooth, accurate stock management
                              designed to keep your business one step ahead.
                            </p>
                          </div>
                        )}
                        <div className="btn-container" align="center">
                          <button
                            id='toggle'
                            onClick={() =>
                              this.setState({
                                expanded2: !this.state.expanded2,
                              })
                            }
                          >
                            {this.state.expanded2 ? "Read Less" : "Read More"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sec2 sec2A">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6 space1">
                        <h2 className="txt-title-3">
                          Timely Alerts for Faster Payments
                        </h2>
                        <span className="line"></span>
                        <p className="txt-style1">
                          Chasing payments can be time-consuming—but not with{" "}
                          <strong>Vyavsay</strong>. Our software automatically
                          sends smart reminders to clients before and after due
                          dates, so you don’t have to follow up manually. It's
                          the easiest way to keep your cash flow steady and
                          professional relationships intact.{" "}
                          {this.state.expanded3 ? "" : "..."}
                        </p>
                        {this.state.expanded3 && (
                          <div>
                            <br />
                            <p className="txt-style1">
                              <h4>Why we’re better:</h4>
                              <ul>
                                <li>
                                  <strong>Automated Alerts:</strong> Schedule
                                  SMS or email reminders that go out without you
                                  lifting a finger.
                                </li>
                                <li>
                                  <strong>Faster Payments:</strong> Gentle
                                  nudges encourage clients to pay on
                                  time—reducing delays and improving business
                                  health.
                                </li>
                              </ul>
                            </p>
                          </div>
                        )}
                        <div className="btn-container" align="center">
                          <button
                            id='toggle'
                            onClick={() =>
                              this.setState({
                                expanded3: !this.state.expanded3,
                              })
                            }
                          >
                            {this.state.expanded3 ? "Read Less" : "Read More"}
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <img
                          src={
                            global.webUrl + "websiteFilesFolder/img/sec3.png"
                          }
                          alt=""
                          title=""
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sec4">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <h2 className="txt-title-3">
                          TAX filing made simpler and faster
                        </h2>
                        <span className="line"></span>
                        <p className="txt-style1">
                          TAX filing is no longer a long process for vyavsay
                          software users. If TAX applies to your business, you
                          can quickly generate all TAX reports{" "}
                          {this.state.expanded4
                            ? "CSS is designed primarily to enable the separation of document content from document presentation, including aspects such as the layout, colors, and fonts. This separation can improve content accessibility, provide more flexibility and control in the specification of presentation characteristics, enable multiple HTML pages to share formatting by specifying the relevant CSS in a separate .css file, and reduce complexity and repetition in the structural content."
                            : "..."}
                        </p>
                        {this.state.expanded4 && (
                          <div>
                            <p className="txt-style1">
                              <br />
                              <br />
                              Separation of formatting and content makes it
                              possible to present the same markup page in
                              different styles for different rendering methods,
                              such as on-screen, in print, by voice (via
                              speech-based browser or screen reader), and on
                              Braille-based tactile devices. It can also display
                              the web page differently depending on the screen
                              size or viewing device. Readers can also specify a
                              different style sheet, such as a CSS file stored
                              on their own computer, to override the one the
                              author specified.
                            </p>
                          </div>
                        )}

                        <div className="btn-container" align="center">
                          <button
                            id='toggle'
                            onClick={() =>
                              this.setState({
                                expanded4: !this.state.expanded4,
                              })
                            }
                          >
                            {this.state.expanded4 ? "Read Less" : "Read More"}
                          </button>
                        </div>
                        <br />
                        <br />
                        <div align="center">
                          <img
                            src={
                              global.webUrl + "websiteFilesFolder/img/sec4.png"
                            }
                            alt=""
                            title=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sec5">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <h2 className="txt-title-3 tt3">Vyavsay Smart Features</h2>
                        <span className="line l2"></span>
                      </div>
                    </div>

                    <div className="row rowE">
                      <div className="col-lg-4">
                        <div className="icon">
                          <span>
                            <i className="far fa-file-alt"></i>
                          </span>
                        </div>
                        <div className="content">
                          <h4>Send Estimates & Quotations</h4>
                          <p>
                            With <strong>Vyavsay</strong>, creating and sharing professional estimates or quotations takes just a few clicks.
                          </p>
                        </div>
                        <div className="clearfix"></div>
                      </div>
                      <div className="col-lg-4">
                        <div className="icon">
                          <span>
                            <i className="fas fa-weight"></i>
                          </span>
                        </div>
                        <div className="content">
                          <h4>Track Orders</h4>
                          <p>
                            Stay in control of your business with real-time order tracking. Vyavsay helps you monitor the entire order journey, from confirmation to delivery—no missed updates, no confusion.
                          </p>
                        </div>
                        <div className="clearfix"></div>
                      </div>
                      <div className="col-lg-4">
                        <div className="icon">
                          <span>
                            <i className="far fa-list-alt"></i>
                          </span>
                        </div>
                        <div className="content">
                          <h4>Choose Themes</h4>
                          <p>
                            Your documents, your style. Vyavsay lets you pick from a range of sleek invoice and quotation themes, so your business always looks polished and professional.
                          </p>
                        </div>
                        <div className="clearfix"></div>
                      </div>
                      <div className="col-lg-4">
                        <div className="icon">
                          <span>
                            <i className="fas fa-wallet"></i>
                          </span>
                        </div>
                        <div className="content">
                          <h4>Record Expences</h4>
                          <p>
                            Easily log daily business expenses and categorize them with Vyavsay. Keep an eye on spending, reduce financial leaks, and simplify your tax preparation.
                          </p>
                        </div>
                        <div className="clearfix"></div>
                      </div>
                      <div className="col-lg-4">
                        <div className="icon">
                          <span>
                            <i className="fas fa-sync"></i>
                          </span>
                        </div>
                        <div className="content">
                          <h4>Recievables & Payble</h4>
                          <p>
                            Know what’s coming in and what’s going out. Vyavsay helps you track all customer dues and vendor payments in one place—making cash flow management easy.
                          </p>
                        </div>
                        <div className="clearfix"></div>
                      </div>
                      <div className="col-lg-4">
                        <div className="icon">
                          <span>
                            <i className="fas fa-truck-moving"></i>
                          </span>
                        </div>
                        <div className="content">
                          <h4>Delivery Challan</h4>
                          <p>
                            Generate and print delivery challans instantly. Vyavsay ensures accurate records of goods dispatched, helping you maintain clear logistics and avoid disputes.
                          </p>
                        </div>
                        <div className="clearfix"></div>
                      </div>
                    </div>
                    <div className="" align="center">
                      <a href={global.webUrl + "features/"} id="togglef">
                        View More Features
                      </a>
                    </div>
                  </div>
                </section>

                <section className="sec6">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <h6 className="txt-style-4">Our Testimonials</h6>
                        <h2 className="txt-style-5">
                          What People Are Saying About Our Business.
                        </h2>
                        <p className="txt-style2A">
                          Using our single innovative platform you can remove
                          all your communication dependencies and the messy
                          rat's nest of email, calls, texts, wikis, and apps you
                          currently have.
                        </p>
                      </div>
                      <div className="col-lg-6">
                        <div
                          className="carousel slide"
                          id="main-carousel"
                          data-ride="carousel"
                        >
                          <ol className="carousel-indicators">
                            <li
                              data-target="#main-carousel"
                              data-slide-to="0"
                              className="active"
                            ></li>
                            <li
                              data-target="#main-carousel"
                              data-slide-to="1"
                            ></li>
                            <li
                              data-target="#main-carousel"
                              data-slide-to="2"
                            ></li>
                            <li
                              data-target="#main-carousel"
                              data-slide-to="3"
                            ></li>
                          </ol>
                          <div className="carousel-inner">
                            <div className="carousel-item active">
                              <div className="testimonial">
                                <h6>
                                  I've been patiently waiting for this to arrive
                                  after using vyavsaay a while on my project.
                                  Keep up the good work! This is fantastic work
                                  as usual byGood Themes. Keep up the good work!{" "}
                                </h6>
                                <ul>
                                  <li>
                                    <img
                                      src={
                                        global.webUrl +
                                        "websiteFilesFolder/img/user.png"
                                      }
                                      alt=""
                                      title=""
                                    />
                                    <b>Jesika Fennouni</b>
                                  </li>
                                  <li>
                                    <i className="fas fa-quote-right"></i>
                                  </li>
                                </ul>
                                <div className="clearfix"></div>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="testimonial">
                                <h6>
                                  I've been patiently waiting for this to arrive
                                  after using vyavsaay a while on my project.
                                  Keep up the good work! This is fantastic work
                                  as usual byGood Themes. Keep up the good work!{" "}
                                </h6>
                                <ul>
                                  <li>
                                    <img
                                      src={
                                        global.webUrl +
                                        "websiteFilesFolder/img/user.png"
                                      }
                                      alt=""
                                      title=""
                                    />
                                    <b>Jesika Fennouni</b>
                                  </li>
                                  <li>
                                    <i className="fas fa-quote-right"></i>
                                  </li>
                                </ul>
                                <div className="clearfix"></div>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="testimonial">
                                <h6>
                                  I've been patiently waiting for this to arrive
                                  after using vyavsaay a while on my project.
                                  Keep up the good work! This is fantastic work
                                  as usual byGood Themes. Keep up the good work!{" "}
                                </h6>
                                <ul>
                                  <li>
                                    <img
                                      src={
                                        global.webUrl +
                                        "websiteFilesFolder/img/user.png"
                                      }
                                      alt=""
                                      title=""
                                    />
                                    <b>Jesika Fennouni</b>
                                  </li>
                                  <li>
                                    <i className="fas fa-quote-right"></i>
                                  </li>
                                </ul>
                                <div className="clearfix"></div>
                              </div>
                            </div>
                            <div className="carousel-item">
                              <div className="testimonial">
                                <h6>
                                  I've been patiently waiting for this to arrive
                                  after using vyavsaay a while on my project.
                                  Keep up the good work! This is fantastic work
                                  as usual byGood Themes. Keep up the good work!{" "}
                                </h6>
                                <ul>
                                  <li>
                                    <img
                                      src={
                                        global.webUrl +
                                        "websiteFilesFolder/img/user.png"
                                      }
                                      alt=""
                                      title=""
                                    />
                                    <b>Jesika Fennouni</b>
                                  </li>
                                  <li>
                                    <i className="fas fa-quote-right"></i>
                                  </li>
                                </ul>
                                <div className="clearfix"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <section className="sec4 sec4A">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <h2 className="txt-title-3">vyavsay Latest News</h2>
                        <span className="line"></span>
                      </div>
                    </div>
                    <div className="row space1">
                      {this.viewWebsiteBlogListing()}
                    </div>
                    <a href={global.webUrl + "blogs/"} className="k2o">
                      View More Blogs
                    </a>
                  </div>
                </section>

                <section className="faq_contact">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <h2 className="txt-style-5">
                          Frequently Asked Questions
                        </h2>
                        <span className="line line1"></span>
                        <div id="accordion" className="accordion">
                          <div className="card mb-0">
                            <div
                              className="card-header"
                              data-toggle="collapse"
                              href="#collapseOne"
                            >
                              <a className="card-title">
                                What is billing and invoicing software?
                              </a>
                            </div>
                            <div
                              id="collapseOne"
                              className="card-body collapse show"
                              data-parent="#accordion"
                            >
                              <p>
                                Professional billing and invoicing software are
                                used to create personalized invoices for
                                businesses. These invoices help reflect the
                                brand’s identity and cater to the brand’s
                                message to clients. Using vyavsay as
                                professional billing app, you can stand out
                                among competitors with appealing invoice design.
                                Further, you can track down paid and unpaid
                                invoices and send payment reminders to the
                                customers directly from the app.
                              </p>
                            </div>
                            <div
                              className="card-header collapsed"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseTwo"
                            >
                              <a className="card-title">
                                Which is the best billing software for small
                                businesses in India?
                              </a>
                            </div>
                            <div
                              id="collapseTwo"
                              className="card-body collapse"
                              data-parent="#accordion"
                            >
                              <p>
                                vyavsay billing software is the best tool for
                                small business owners who need help managing
                                their finances and accounts. Using our billing
                                tool, you can save a lot of time and efforts in
                                creating an invoice for every customer.
                              </p>
                            </div>
                            <div
                              className="card-header collapsed"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree"
                            >
                              <a className="card-title">
                                What is the difference between invoices and
                                bills?
                              </a>
                            </div>
                            <div
                              id="collapseThree"
                              className="collapse"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <p>
                                  Although invoices and bills both outline how
                                  much money a customer owes to a business, they
                                  differ in some ways. An invoice must contain
                                  an invoice number, which is not mandatory in
                                  caseof a bill. The invoice includes details
                                  about everything included in a product or
                                  service, while a bill can have little
                                  information to get an overview of a
                                  transaction.
                                </p>
                              </div>
                            </div>
                            <div
                              className="card-header collapsed"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree1"
                            >
                              <a className="card-title">
                                What are the types of billing?
                              </a>
                            </div>
                            <div
                              id="collapseThree1"
                              className="collapse"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <p>
                                  Billing, in general, is categorized as:
                                  <br />
                                  1. Order-based billing: It is used for bills
                                  with a fixed scope of work or a fixed number
                                  of items to be delivered.
                                  <br />
                                  2. Delivery-based billing:It is used for bills
                                  that include an estimate of the cost involved
                                  as per the customer’s requirements.
                                </p>
                              </div>
                            </div>
                            <div
                              className="card-header collapsed"
                              data-toggle="collapse"
                              data-parent="#accordion"
                              href="#collapseThree2"
                            >
                              <a className="card-title">
                                List some top features of billing software?
                              </a>
                            </div>
                            <div
                              id="collapseThree2"
                              className="collapse"
                              data-parent="#accordion"
                            >
                              <div className="card-body">
                                <p>
                                  Here are some essential features of billing
                                  software.
                                  <br />
                                  1. Creating quotations and estimates
                                  <br />
                                  2. Managing inventory and stock
                                  <br />
                                  3. Converting quotes to invoices
                                  <br />
                                  4. Setting alerts and reminders
                                  <br />
                                  5. Compatibility with mobile devices
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="get_in_touch">
                          <h2>Get In Touch</h2>
                          <span></span>
                          <form>
                            <div>
                              <input
                                className={
                                  errors.name.length > 0 && "errorClass"
                                }
                                value={this.state.name}
                                onChange={this.handleChange}
                                type="text"
                                placeholder="Name"
                                name="name"
                                required
                                style={{ color: "white" }}
                              />
                            </div>
                            <div>
                              <input
                                className={
                                  errors.email.length > 0 && "errorClass"
                                }
                                value={this.state.email}
                                onChange={this.handleChange}
                                type="email"
                                placeholder="Email"
                                id="email"
                                name="email"
                                required
                                style={{ color: "white" }}
                              />
                            </div>
                            <div>
                              <input
                                className={
                                  errors.contact.length > 0 && "errorClass"
                                }
                                value={this.state.contact}
                                onChange={this.handleChange}
                                type="text"
                                placeholder="Phone No."
                                name="contact"
                                required
                                style={{ color: "white" }}
                              />
                            </div>
                            <div>
                              <textarea
                                className={
                                  errors.message.length > 0 && "errorClass"
                                }
                                value={this.state.message}
                                onChange={this.handleChange}
                                placeholder="Message"
                                name="message"
                                required
                                style={{ color: "white" }}
                              ></textarea>
                            </div>
                            <div>
                              <button
                                type="button"
                                disabled={isDisabled}
                                onClick={this.clickToSubmitEnqury}
                              >
                                Submit
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* Footer Code Here */}
                <FooterPage />
              </div>
            </div>
            {this.state.visibleStartBtn && (
              <Dialog title={this.state.mailsendTitle} onClose={() => this.setState({visibleStartBtn: false})}>
                <p style={{
                    margin: "25px",
                    textAlign: "center",
                  }} dangerouslySetInnerHTML={{ __html: this.state.mailsendMessage }}></p>
                <DialogActionsBar>
                  <button type="submit" className="btn btn-primary text-right" onClick={() => this.setState({visibleStartBtn: false})}>Close</button>
                </DialogActionsBar>
              </Dialog>
            )}
            {this.state.visibleMailsendDialog && (
                <Dialog title={this.state.mailsendTitle} onClose={() => this.setState({visibleMailsendDialog: false})}>
                <p
                    style={{
                    margin: "25px",
                    textAlign: "center",
                    }}
                >
                    {this.state.mailsendMessage}
                </p>
                <DialogActionsBar>
                    <button type="submit" className="btn btn-primary text-right" onClick={() => this.setState({visibleMailsendDialog: false})}>Ok</button>
                </DialogActionsBar>
                </Dialog>
            )} 
            {
                this.state.isLoading && (
                    <Dialog >
                    <Loader type="converging-spinner" />
                    </Dialog>
                )
            }
          </React.Fragment>
        );
    }
}